import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/pages/404.vue'
import routes from "@/router/index.js";
import store from "@/store";

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: "*",
      name: "404 - Page Not Found",
      component: NotFound
    }
  ].concat(routes)
})


router.beforeEach((to, from, next) => {
  
  const isAuthenticated = store.getters.hasToken;
  //const onlyLoggedOut = to.matched.some(record => record.meta.onlyLoggedOut);
  const isPublic = to.matched.some(record => record.meta.public);
  //const UNAUTHORIZED = 401;

  if (!isPublic && !isAuthenticated) {
    return next({
      path: "/home",
      query: { redirect: to.fullPath }
    });
  }

  //if (isAuthenticated && onlyLoggedOut) {
  //  return next("/");
  //}

  next();
});

export default router;

